import { render } from "./BannerListPage.vue?vue&type=template&id=194f47a0"
import script from "./BannerListPage.vue?vue&type=script&lang=js"
export * from "./BannerListPage.vue?vue&type=script&lang=js"
script.render = render

export default script